import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
// import { SlEye } from 'react-icons/sl'
import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Avatar, Button, Divider, Drawer, Dropdown, Form, Image, Input, Select, Space, Tag, Upload, notification } from 'antd'
import eventImage from '../../../assets/gallery/event.png'
import { handleConfirm, handleTableSelect, statusType } from '../../../context/utils'
import CustomTable from '../../../components/CustomTable'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
import { BiEdit, BiUser } from 'react-icons/bi'
import { LuFileUp } from 'react-icons/lu'
import { GoTrash } from 'react-icons/go'
import { ImStopwatch } from 'react-icons/im'
import { CiCalendarDate, CiLocationOn } from 'react-icons/ci'
import { useDeleteBrand, useGetBrand, useGetBrands, usePatchBrand, usePostBrand } from '../../../hooks/brands/brands'
import { useGetProducts } from '../../../hooks/products/products'
import SearchPage from '../../../components/searchPage'

function BrandsManagementPage() {
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [search, setSearch] = useState('')
  const [isViewOpen, setIsViewOpen] = useState(false)
  const [image, setImage] = useState({})
  const onCreateOpen = () => setIsCreateOpen(true)
  const onViewClose = () => setIsViewOpen(false)
//   const onViewOpen = () => setIsViewOpen(true)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const onOpenEdit = () => setIsOpenEdit(true)
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()

  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setRows([])
  }
  
  const onCloseEdit = () => {
    setIsOpenEdit(false)
    form.resetFields();
  }
   
  const [createPayload, setCreatePayload] = useState({    
    name: "",
    productIds: "",
    imageFile: "",
    id:"",
    // isActive:""
})

  const {
    data: getBrandData,
    refetch: getBrandFetch,
    isFetching: getBrandLoad,
  } = useGetBrands(
    {SearchString: search},
    ["SearchString"],
  )
  
const {
  data: getProductsData,
  isFetching: getProductsLoad,
} = useGetProducts()

const {
  data: getData,
  mutate: getAction,
  isLoading: getLoad,
} = useGetBrand(onOpenEdit)

  const successAction = () => {
    form.resetFields();
    getBrandFetch();
    onCloseEdit()
    onViewClose()
  };

  useEffect(() => {
    setCreatePayload({
      name: getData?.data?.name || "",
      // description: getData?.data?.description || "",
      // isActive: getData?.data?.isActive || "",
      // productIds: getData?.data?.productIds || [],
      productIds: getData?.data?.products?.map((e)=>(e?.id)) || [],
      imageFile: getData?.data?.imageUrl || "",
      id: getData?.data?.id || "",
    })
    
  }, [getData?.data])
  const uploadProps = useMemo(() => ({
    name: 'file',
    method: 'GET',
    multiple: false,
    data: image?.file,
    onChange({file, fileList}) {
      setImage({
        file,
        name: file?.name,
        fileObj: file?.originFileObj,
        url: URL.createObjectURL(file?.originFileObj),
      })
      // setCreatePayload({...createPayload, imageFile: file?.originFileObj})
    }
  }), [image]);

  const {
    mutate: postBrandAction,
    isLoading: postBrandLoad,
  } = usePostBrand(successAction)

  const {
    mutate: putAction,
    isLoading: putLoad,
  } = usePatchBrand(successAction)

  
  const {
    mutate: deleteAction,
    isLoading: deleteLoad,
  } = useDeleteBrand(successAction)

//   const handleView = ({target:{id}}) => {
//     onViewOpen()
//   }
  const handleEdit = (d) => {    
    getAction(d.id)
  }


  const columns = [
    {
      title: "Brands Name",
      dataIndex: "name",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        <Avatar src="">{e?.charAt(0)}</Avatar>
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key:"2",
      render: (e) => 
      <Tag className={`{${e} ? ${statusType?.active?.col} : ${statusType?.inactive?.col}} ${e} ? ${statusType?.active?.bd} : ${statusType?.inactive?.bd}} font-bold rounded-2xl px-3 py-0.5`}>{e ? "ACTIVE" : "INACTIVE"}</Tag>
    },
    {
      title: "Brand Image",
      dataIndex: "imageUrl",
      key:"3",
      render: (e) => 
        <Image src={e} alt='vRV' width={70} />
    },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft"
        menu={{items: [
          // {key: "view", icon: <SlEye className='!text-base' />, label: <button id=''>View</button>},
          {key: "edit", label: <button className='flex' onClick={()=>handleEdit(data)}><BiEdit className='!text-base mx-4 py-auto' /> Edit</button>},
          // {key: "delete", icon: <GoTrash className='!text-base mx-4 py-auto' />, label: <button className='flex' onClick={() => handleConfirm({})}>Delete</button>},
          {key: "delete", label: <button className='flex' onClick={() => handleConfirm({data: data?.id, action: deleteAction})}><GoTrash className='!text-base mx-4 py-auto' /> Delete</button>},

        ]}}
      >
        <Button loading={getLoad || postBrandLoad || putLoad || deleteLoad} className='!bg-[#F2F6FC]' type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]
  const onSubmit = (d) => {
    const isActive = !d.isActive ? true : d.isActive;
    if (!image?.fileObj) {
      notification.error({
        message: "Failed!",
        description: "Please Image is Required",
      })
    }else{
      const payload = {
          isActive,
          name: d.name,
          ImageFile: image?.fileObj,
          productIds: d.productIds,
          description: d.description
        }
        postBrandAction(payload)
    }
  }
  const onSubmitEdit = () => {
    putAction(createPayload)
    // console.log(createPayload)

  }

  return (
    <PadContainer loading={getBrandLoad || getProductsLoad}>
      <TitleContainer
        path={false}
        title="Brands Management"
        className="border border-lit rounded-xl"
        action={
        <div className='flex'>
          <SearchPage setSearch={setSearch} size='' />
          <Button onClick={onCreateOpen} className='!bg-light_blue' type='primary' size='large' icon={<FaPlus />}>Add Brands</Button>
        </div>}
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getBrandData?.data?.data}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
      </TitleContainer>


      {/* create edit drawer */}
      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>New Brands</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <Form.Item label="Brand Name" name="name">
            <Input size='large' placeholder='Brand Name' />
          </Form.Item>
          <Form.Item label="Category" name="productIds">
            <Select size='large' placeholder='Select Categories' mode="multiple">              
              {getProductsData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          {/* <Form.Item label="Description" name="description">
            <Input.TextArea placeholder='Enter description' size='large' rows={4} />
          </Form.Item> */}
          <Form.Item>
            <Upload {...uploadProps}>
              <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
            </Upload>
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      <Drawer
        open={isOpenEdit}
        onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Brand</p>}
      >
        
        <Form
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
          form={form}
        >
          <Form.Item label="Brand Name" rules={[{required: true, message: 'Please input Brand Name!',},]}>
            <Input 
                size='large' 
                placeholder='Enter Brand name' 
                prefix={<BiUser />} 
                value={createPayload.name}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, name: value})}
            />
          </Form.Item>

          <Form.Item label="Category">
            <Select 
                size='large' 
                placeholder='Select Categories' 
                mode="multiple"
                // defaultValue={getRoleData?.data?.permissions?.map((e)=>(e?.id))}                
                value={createPayload.productIds}
                onChange={(value)=> setCreatePayload({...createPayload, productIds: value})}
            >
              {getProductsData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          {/* <Form.Item label="Description" rules={[{required: true, message: 'Please input Description!',},]}>
            <Input.TextArea 
                placeholder='Enter Description' 
                size='large'                 
                value={createPayload.description}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, description: value})}
            />
          </Form.Item> */}
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>            
            <Form.Item>
              <Upload {...uploadProps} listType="picture">
                <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
              </Upload>
            </Form.Item>
            <Form.Item>
              <Space size={12}>
                <Image
                  width={100}
                  src={createPayload.name}
                  placeholder={
                    <Image
                      preview={false}
                      src={createPayload.name}
                      width={200}
                    />
                  }
                />
              </Space>
            </Form.Item>
          </div>

          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCloseEdit} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' onClick={onSubmitEdit} loading={putLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Update</Button>
          </div>
        </Form>
      </Drawer>

      {/* view drawer */}
      <Drawer
        open={isViewOpen}
        onClose={onViewClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Brands</p>}
      >
        <div className='w-full'>
          <div className='flex gap-3 items-center'>
            <Image alt='Brands image' src={eventImage} />
            <div className='space-y-3'>
              <p className='text-2xl font-bold text-light_blue'>Kings’s Day Parade</p>
              <Tag className={`${statusType?.info?.bg} ${statusType?.secondary?.col} ${statusType?.info?.bd} font-bold rounded-2xl px-3 py-0.5`}>Active</Tag>
            </div>
          </div>
          <Divider />
          <div className='w-full rounded-xl bg-[#FEFAF2] px-5 divide-y'>
            {[
              {Icon: CiLocationOn, value: "Mandeville"},
              {Icon: ImStopwatch, value: "2pm"},
              {Icon: CiCalendarDate, value: "12 December, 2023"},
            ].map(({Icon, value}) => (
              <div className='flex items-center gap-3 py-5'>
                <Button className='!bg-[#FDE9C2] !text-[#F5A302]' icon={<Icon className="!text-xl" />} shape='circle' size='large' type='primary' />
                <p className='text-lg font-semibold text-silver'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            {[
              {label: "Route From", value: "Lagos"},
              {label: "Route To", value: "Germany"},
              {label: "Category", value: "Music and Entertainment"},
              {label: "Created by", value: "Admin"},
            ].map(({label, value}) => (
              <div className='flex items-center gap-3'>
                <p className='text-base text-light_blue font-semibold'>{label}: </p>
                <p className='text-base text-dim font-medium'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 flex justify-between items-center'>
            <div className='flex items-center gap-5'>
              <p className='text-base text-light_blue font-semibold'>Attendees:</p>
              <Avatar.Group
                maxCount={4}
                maxPopoverTrigger="click"
                maxStyle={{ color: '#F5A302', backgroundColor: '#002C70', cursor: 'pointer' }}
              >
                {Array.from(Array(100).keys()).map(idx => (
                  <Avatar>{idx}</Avatar>
                ))}
              </Avatar.Group>
            </div>
            <Button className='!bg-lint text-dim' type='primary' size='small'>View All</Button>
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            <p className='text-base text-light_blue font-semibold'>Description</p>
            <p className='text-sm text-dim font-normal'>Celebrate the vibrant spirit of our community at our annual Parade Spectacular! Join us for a lively and colourful procession weaving through the heart of [City/Town Name], featuring magnificent floats, marching bands, and dazzling performances.</p>
          </div>
          <Divider />
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={handleEdit} loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Edit</Button>
            <Button className='!text-light_blue !border-light_blue' size='large'>Delete</Button>
          </div>
        </div>
      </Drawer>
    </PadContainer>
  )
}

export default BrandsManagementPage